module.exports = ".btn-default, .btn-default:focus {\n  border-color: #d9d9d9; }\n\n.form-groups .group.has-error > a {\n  position: relative; }\n\n.form-groups .group.has-error > a > span.badge {\n  position: absolute;\n  left: 10px;\n  top: 15px;\n  font-size: 0.8em; }\n\n.form-groups .group.has-error > a > span:not(.badge) {\n  margin-left: 15px; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/forms/form/components/form/form.component.scss
// module id = ./libs/chassis-core/src/app/forms/form/components/form/form.component.scss
// module chunks = main